import React, { useState } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';

const SelectedProduct = ({title, price, }) => {
    const [formData, setFormData] = useState('')
    const handleChange = ()=>{

    }
  return (
    <Box>
        <Box sx={{border:'1px solid rgba(231, 231, 231, 1)', backgroundColor:'rgba(255, 255, 255, 1)', borderRadius:'12px', my:4}}>
            <Typography sx={{backgroundColor:'rgba(110, 107, 123, 0.5)', color:'rgba(255, 255, 255, 1)', px:2, py:1, borderRadius:'12px 12px 0 0'}}>
                Your Selected Product
            </Typography>
            <Typography sx={{display:'flex', justifyContent:'space-between',px:2, py:1}}>
                <span>{title}</span>
                <span style={{fontWeight:'600'}}>
                    {price}
                </span>
            </Typography>
        </Box>
        <Box sx={{my:2}}>
            <Typography>
                Promo Code
            </Typography>
            <form style={{display:'flex', gap:'1rem', alignItems:'center'}}>
            <Box sx={{display:'flex', justifyContent:'center', width:'70%'}}>
                <TextField value={formData}
                    onChange={handleChange} placeholder='enter tracking number' sx={{my:2}} fullWidth/>
            </Box>
            <Button variant="contained"
                required
                  sx={{minWidth:'30%',display:'flex', alignItems:'center', gap:1, textTransform:'none', color:'rgba(255, 255, 255, 1)', boxShadow:'none', backgroundColor:'rgba(18, 18, 18, 1)', p:0, height:'45px', borderRadius:'100px'}}>Apply</Button>
        </form>
        </Box>
        <Box sx={{border:'1px solid rgba(231, 231, 231, 1)', backgroundColor:'rgba(255, 255, 255, 1)', borderRadius:'12px', my:4}}>
            <Typography sx={{display:'flex', justifyContent:'space-between',p:2, borderBottom:'1px solid rgba(231, 231, 231, 1)'}}>
                <span>Sub Total</span>
                <span style={{fontWeight:'600'}}>
                    {price}
                </span>
            </Typography>
            <Typography sx={{display:'flex', justifyContent:'space-between',p:2, borderBottom:'1px solid rgba(231, 231, 231, 1)'}}>
                <span>Discount</span>
                <span style={{fontWeight:'600'}}>
                    {price}
                </span>
            </Typography>
            <Typography sx={{display:'flex', justifyContent:'space-between',p:2, borderBottom:'1px solid rgba(231, 231, 231, 1)'}}>
                <span>Delivery</span>
                <span style={{fontWeight:'600'}}>
                    {price}
                </span>
            </Typography>
            <Typography sx={{display:'flex', justifyContent:'space-between',p:2, backgroundColor:'rgba(246, 167, 4, 1)', borderRadius: '0 0 12px 12px'}}>
                <span>Total Price</span>
                <span style={{fontWeight:'600'}}>
                    {price}
                </span>
            </Typography>
        </Box>
        <Box sx={{borderTop:'1px solid rgba(110, 107, 123, 1)', mt:6}}>
        <Button variant="contained"
                  sx={{width:'100%', my:3,display:'flex', alignItems:'center', gap:1, textTransform:'none', color:'rgba(255, 255, 255, 1)', boxShadow:'none', backgroundColor:'rgba(86, 4, 246, 1)', p:2, minWidth:'fit-content', borderRadius:'100px', ':hover': {
            backgroundColor:'#4f03e7', 
            fontWeight:600,
            boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
          }}}>Complete Checkout</Button>
          <Button variant="contained"
                  sx={{width:'100%', my:2,display:'flex', alignItems:'center', gap:1, border:'1px solid rgba(86, 4, 246, 1)', textTransform:'none', color:'rgba(86, 4, 246, 1)', boxShadow:'none', backgroundColor:'rgba(225, 225, 225, 1)', p:2, minWidth:'fit-content', borderRadius:'100px', ':hover': {
            backgroundColor:'#4f03e7', 
            fontWeight:600,
            color:'rgba(225, 225, 225, 1)',
            boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
          }}}>Complete Checkout</Button>
        </Box>
    </Box>
  )
}

export default SelectedProduct